import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RecoveryComponent } from './components/recovery/recovery.component';
import { ValidatecodeComponent } from './components/validatecode/validatecode.component';
import { NewpasswordComponent } from './components/newpassword/newpassword.component';
import { NewPasswordDialog } from './components/newpassword/newpassword.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ModalChoiceComponent } from './components/modal-choice/modal-choice.component'
import { NgOtpInputModule } from 'ng-otp-input';
import { HttpClientModule } from '@angular/common/http'
import { TextMaskModule } from 'angular2-text-mask';
import { ModalMensageComponent } from './components/modal-mensage/modal-mensage.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
  declarations: [
    AppComponent,
    RecoveryComponent,
    ValidatecodeComponent,
    NewpasswordComponent,
    NewPasswordDialog,
    ModalChoiceComponent,
    ModalMensageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxMaskModule.forRoot(),
    NgOtpInputModule,
    HttpClientModule,
    TextMaskModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
